import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Avatar,
  Box
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PlaceIcon from '@mui/icons-material/Place';
import EventIcon from '@mui/icons-material/Event';
import './MissionsList.css';
import { useNavigate } from 'react-router-dom';

const MissionItem = ({ mission, onView }) => {
  const [logoError, setLogoError] = useState(false);
  const navigate = useNavigate();

  const logoUrl = mission.logo ? `${process.env.REACT_APP_API_BASE_URL}${mission.logo}` : '';
  const fallbackInitial = mission.NomEntreprise?.charAt(0)?.toUpperCase() || 'E';

  return (
    <Card className="mission-compact-card" elevation={1}>
      <CardContent className="mission-compact-content">

        {/* Logo + badge */}
        <div className="logo-wrapper-with-name">
          <div className="logo-wrapper">
            {!logoError && logoUrl ? (
              <img
                src={logoUrl}
                alt={mission.NomEntreprise || 'Entreprise'}
                className="mission-compact-logo"
                onError={() => setLogoError(true)}
              />
            ) : (
              <Avatar variant="rounded" className="mission-compact-avatar">
                {fallbackInitial}
              </Avatar>
            )}
            {mission.isNew && <span className="badge-new">NOUVEAU</span>}
          </div>
        </div>

        <Box className="mission-compact-info">
          <Box
            className="company-row"
            onClick={() => navigate(`/profil-entreprise/${mission.createdBy._id}`)}
            sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >
            <BusinessIcon fontSize="small" className="icon-small" />
            <Typography variant="subtitle2" className="company-name" noWrap>
              {mission.NomEntreprise || "Entreprise"}
            </Typography>
          </Box>

          <Box onClick={() => onView(mission._id)} sx={{ cursor: 'pointer' }}>
            <Typography variant="subtitle1" className="mission-title" noWrap>
              {mission.nomMission}
            </Typography>
          </Box>

          <Typography
            variant="body2"
            className="mission-context"
            title={mission.contexteMission || ''}
          >
            {mission.contexteMission
              ? (mission.contexteMission.length > 150
                  ? mission.contexteMission.substring(0, 150) + '…'
                  : mission.contexteMission)
              : 'Pas de description disponible'}
          </Typography>

          <Box className="meta-row">
            <PlaceIcon fontSize="small" className="icon-small" />
            <Typography variant="caption" className="meta-text" noWrap>
              {mission.lieuxTravail || "France"}
            </Typography>

            <EventIcon fontSize="small" className="icon-small" />
            <Typography variant="caption" className="meta-text" noWrap>
              {new Date(mission.createdAt || Date.now()).toLocaleDateString()}
            </Typography>
          </Box>
        </Box>

        <Box className="prime-and-btn">
          <Box className="prime-box">
            <MonetizationOnIcon style={{ color: '#43a047', marginRight: 4 }} />
            <Typography variant="subtitle2" className="prime-text" noWrap>
              {mission.remuneration || 0} {mission.devise || ""}
            </Typography>
          </Box>
        </Box>

      </CardContent>
    </Card>
  );
};

export default function MissionsList({ missions, onView = () => {} }) {
  const lastMissions = missions.slice(0, 4);

  return (
    <div className="missions-list-compact">
      {lastMissions.map((m, i) => (
        <MissionItem key={m._id || i} mission={m} onView={onView} />
      ))}
    </div>
  );
}
